import React from 'react';

export default function About() {
	return (
		<section id="nosotros" className="py-12 bg-slate-50">
			<div className="max-w-7xl mx-auto px-4">
				<h2 className="text-3xl font-bold mb-4">Sobre Nosotros</h2>
				<p className="text-slate-600">Equipo de geólogos, químicos e ingenieros metalúrgicos con más de 15 años de experiencia.</p>
			</div>
		</section>
	);
}
